// dataLayer dont exist locally so this will throw errors in console.
$(document).ready(function () {
    $('#loginButton').click(function () {
        dataLayer.push({
            event: 'interpreting-loginEmail'
        });
    });
    $('#externalLoginButton').click(function () {
        dataLayer.push({
            event: 'interpreting-loginAD'
        });
        return true;
    });
    $('.forgotpasswordpage #MainForm').submit(function () {
        dataLayer.push({
            event: 'interpreting-forgotPassword'
        });
        return true;
    });
    
});